export function HRDivider(props: { title: string }) {
  return (
    <div className="mx-0 my-2 flex flex-row items-center justify-center p-0">
      <div className="h-0.75 w-full flex-1 bg-gray-300"></div>
      <div className="px-2 text-xs font-semibold text-gray-400">{props.title}</div>
      <div className="h-0.75 w-full flex-1 bg-gray-300"></div>
    </div>
  );
}
